import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "a8d43f0v", // ✅ MUST match your Studio's ID
  dataset: "production",
  apiVersion: "2023-01-01",
  useCdn: false,
});
